
import { InsuranceDetails, PartnerDetails, RiskRestructure } from './insurance-details';
import { Injectable } from '@angular/core';
import { BackendService } from '../../backend.service';
import { Observable } from 'rxjs';
import { RepaymentDayDetails } from './repayment-day-details';

@Injectable()
export class LoanAgreementService {

    private getLoanAgreementUrl = '/loan-agreement/api/v1/agreements/applications/{applicationId}';
    private getInsuranceAvailabilityUrl = '/insurance/api/v1/merchants/{merchantId}/customers/{customerId}/applications/{applicationId}';
    private getInsuranceAmountUrl = '/insurance/api/v1/loans/{loanId}/merchant/{merchantId}?partnerId={partnerId}';
    private insuranceAgreementUrl = '/insurance/api/v1/details/customers';
    private getRepaymentsDaysUrl = '/Repayments/merchants/{merchantId}/repayments-days';
    private setRepaymentsDayUrl = '/Repayments/repayments-day';
    private checkForRestructuredApplicationUrl = '/ApplicationFlow/LoanApplications/{{applicationId}}/ApplicationRestructured';
    private loanRestructureRiskUrl = '/risk_engine/otrocs/restructure/checkout';
    private razorpayGetStatusUrl = '/Razorpay/LoanApplication/{{LoanId}}/Payments';
    private getSanctionLetterURL = '/loan-agreement/api/v1/sanction-letter/applications/{applicationId}';
    private getLenderDetails = '/dashboard/api/v1/lender/{lenderId}/meta';
    private getComplianceConsentUrl = '/customer-details/api/v1/consent/customers/{customerId}';
    private saveComplianceConsentUrl = '/customer-details/api/v1/consent/customers/{customerId}';
    private complianceFeatureSwitchUrl = '/switch/complianceConsentSwitch.json';
    private consentPopupUrl = '/consentModal.json';

    constructor(private backendService: BackendService) { }

    getLoanAgreement(merchantId, applicationId: string): Observable<string> {
        return this.backendService.getData(this.getLoanAgreementUrl.replace('{applicationId}', applicationId), 'text');
    }

    getInsuranceDetails(insuranceName) {
      return this.backendService.getData(`/insurance-coverage-details/${insuranceName}.json`, null, false, true, true);
    }

    getInsuranceAvailability(merchantId, applicationId): Observable<PartnerDetails> {
      return this.backendService.getData(this.getInsuranceAvailabilityUrl.replace('{merchantId}', merchantId).replace('{applicationId}', applicationId));
    }

    getInsuranceAmount(loanId: string, partnerId: string, merchantId: string) {
      return this.backendService.getData(this.getInsuranceAmountUrl.replace('{loanId}', loanId).replace('{partnerId}', partnerId).replace('{merchantId}', merchantId));
    }

    setInsuranceAgreement(insuranceDetails: InsuranceDetails): Observable<string> {
      return this.backendService.setData(this.insuranceAgreementUrl, insuranceDetails);
    }
    getRepaymentsDays(merchantId): Observable<number[]> {
      return this.backendService.getData(this.getRepaymentsDaysUrl.replace('{merchantId}', merchantId));
    }

    setRepaymentsDay(repaymentDayDetails: RepaymentDayDetails): Observable<any> {
      return this.backendService.setData(this.setRepaymentsDayUrl, repaymentDayDetails);
    }
    checkForRestructuredApplication(applicationId: string): Observable<any> {
      return this.backendService.getData(this.checkForRestructuredApplicationUrl.replace('{{applicationId}}', applicationId));
    }
    loanRestructureRiskCheck(postData: RiskRestructure): Observable<any> {
      return this.backendService.setData(this.loanRestructureRiskUrl, postData);
    }
    getPaymentStatus(loanId: string): Observable<any> {
      return this.backendService.getData(this.razorpayGetStatusUrl.replace('{{LoanId}}', loanId));
    }

    getSanctionLetter(applicationId): Observable<any> {
      return this.backendService.getData(this.getSanctionLetterURL.replace('{applicationId}', applicationId));
    }

    getLender(lenderId): Observable<any> {
      return this.backendService.getLenderData(this.getLenderDetails.replace('{lenderId}', lenderId));
    }
    getComplianceConsent(): Observable<any> {
      return this.backendService.getData(this.getComplianceConsentUrl);
    }
    saveComplianceConsent(consents): Observable<any> {
      const { thirdPartyConsent, incomeConsent } = consents;
      const consentBody = [];
      if (thirdPartyConsent && incomeConsent) {
        consentBody.push({
          'houseHoldIncomeConsent': {
            'isAccepted': true,
            'source': 'preapprove'
          },
          'dataSharingConsent': {
            'isAccepted': true,
            'source': 'preapprove'
          }
        });
      } else if (thirdPartyConsent) {
        consentBody.push({
          'dataSharingConsent': {
            'isAccepted': true,
            'source': 'preapprove'
          }
        });
      } else {
        consentBody.push({
          'houseHoldIncomeConsent': {
            'isAccepted': true,
            'source': 'preapprove'
          }
        });
      }
      const data = {
        consents: consentBody
      };
      return this.backendService.putData(this.saveComplianceConsentUrl, data);
    }

    getComplianceFeatureSwitch(): Observable<any> {
      return this.backendService.getData(this.complianceFeatureSwitchUrl, null, false, false, true);
    }

    getConsentPopupData(): Observable<any> {
      return this.backendService.getData(this.consentPopupUrl, null, false, true, true);
    }
}
